module.exports = "<div class=\"tab\">\n  <h1>lorem ipsum dolor sit amet (H1)</h1>\n  <h2>lorem ipsum dolor sit amet (H2)</h2>\n  <h3>lorem ipsum dolor sit amet (H3)</h3>\n  <h4>lorem ipsum dolor sit amet (H4)</h4>\n  <h5>lorem ipsum dolor sit amet (H5)</h5>\n  <h6>lorem ipsum dolor sit amet (H6)</h6>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader?interpolate!./src/components/guideline/templates/styling_titles.html
// module id = 84
// module chunks = 0